import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, NumberSteps, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { TRADING_PROCESS, TRADING_DISCLAIMER } from "../data/content";

export default function TradingProcess() {
    return (
        <div className="grain bg-navy-deep" data-testid="trading-process-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Trading Process | From Requirement to Contract — Viet Medica Ltd",
                        description:
                            "The eight-step trading process used by Viet Medica Ltd — verification, specification matching, documentation, due diligence and contracting.",
                        path: "/trading-process",
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: "Trading Process" }]}
                    eyebrow="International Trading"
                    title="The Trading"
                    titleEm="Process."
                    copy="Every trading enquiry follows a structured path. Verification comes first, commercial details follow, and independent checks protect all parties before contracts are finalised."
                />

                <PageSection testid="trading-process-steps">
                    <NumberSteps steps={TRADING_PROCESS} />
                    <div className="mt-10">
                        <DisclaimerBox text={TRADING_DISCLAIMER} testid="trading-process-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Begin with a clear requirement."
                            primary={{ label: "Trading Enquiry", to: "/trading-enquiry", testid: "process-enquiry-cta" }}
                            secondary={{ label: "Compliance & Due Diligence", to: "/compliance-due-diligence", testid: "process-compliance-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
